import { render, staticRenderFns } from "./machineRequest.vue?vue&type=template&id=3c874e62&"
import script from "@/scripts/extraServiceRequest/machineRequest.js?vue&type=script&lang=js&"
export * from "@/scripts/extraServiceRequest/machineRequest.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports